import { MUTATE, MUTATE_MULTIPLE } from '@/store/modules/mutation_types';
import AccountService from '@/services/AccountService';
import AccountServiceStaging from '@/services/AccountServiceStaging';

export async function getAccount({ commit, state, rootState }, accountId) {
  if (state.account) {
    commit(MUTATE, {
      property: 'requestStatus',
      with: 'success',
    });
    return state.account;
  }

  const isStaging = rootState.dashboard.isStaging;

  const service = isStaging ? AccountServiceStaging : AccountService;

  try {
    const account = await service.account(accountId);

    commit(MUTATE_MULTIPLE, [{
      property: 'account',
      with: account,
    }, {
      property: 'requestStatus',
      with: 'success',
    }]);

    return account;
  } catch (e) {
    console.error(e);
    commit(MUTATE, {
      property: 'requestStatus',
      with: 'error',
    });
  }
}
